import StandUploadFile from "./stand-upload-file";

export default StandUploadFile;


